<app-dialog
  [title]="'Open Case'"
  [actions]="[
  { text: 'Cancel'},
]"
  (action)="action($event)"
  (close)="close()"
>
<div class="openCaseDialog">
  <div class="amazon-case-template p-0">
    <div class="amazon-case">
      <div class="amazon-case_header">
        <div class="amazon-case_header--title"> 
          <mat-form-field appearance="fill" class="mat-select-control mat-select-xs">
            <mat-select [(ngModel)]="selectedTemplate" (ngModelChange)="onChange($event)"  panelClass="templateSelect">
              <mat-option [value]="templateName"
                *ngFor="let templateName of templates"
              >
                {{ templateName?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-menu #showTemplate="matMenu">
          <div class="importBoxesMenu" >
              <div class="importBoxesMenu-wrapper">
                  <div *ngFor="let item of storeTemplateVar" class="importBoxesMenu-wrapper_tags" cdkDrag (click)="selectTemplate(item)">{{item.name}}</div>
              </div>
          </div>
        </mat-menu>
        <div class="amazon-case_header--action d-flex align-items-center">
          <app-button [buttonSize]="'action'" [buttonStyle]="'text'" *ngIf="isEdit" (click)="navigate()"><i class="fal fa-external-link-square-alt"></i></app-button>
          <div class="d-flex" *ngIf="isEdit" [matMenuTriggerFor]="showTemplate">            
            <app-button [buttonSize]="'action'" [buttonStyle]="'text'">
              <svg class="mb-1 me-1" width="10.51" height="12.01"><use xlink:href="assets/images/sprite-icons.svg#clipboard_icon"></use></svg>
              Add Value
            </app-button>
          </div>
          <app-button *ngIf="!isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" (click)="edit()"> Edit</app-button>
          <app-button *ngIf="isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" (click)="cancel()"> Cancel</app-button>
          <app-button *ngIf="isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" (click)="save()"> Apply</app-button>
        </div>
      </div>
        <div class="amazon-case_body" *ngIf="!isEdit">
            <div class="amazon-case_body--templateText h-100" [innerHtml]="selectedTemplate?.templateText">
            </div>
        </div>
        <textarea *ngIf="isEdit" #textArea class="amazon-case_body--templateText w-100 resize-none" [formControl]="textAreaForm">{{templateText}}</textarea>
    </div>
  </div>
  <!-- <div class="text-left mt-2">
    <app-button  [buttonSize]="'action'" [buttonStyle]="'text'" (click)="copy()"><i class="fal fa-copy me-2"></i>Copy to clipboard</app-button>
  </div> -->
  <app-page-container-devider class="my-4 text-dark" [title]="'Selected SKU’s'" [small]="true"></app-page-container-devider>
  <ng-container *ngIf="multipleSelectedRows.length">
    <div class="openCaseDialog-box" *ngFor="let item of multipleSelectedRows; let i = index;">
      <div class="openCaseDialog-boxRow">
        <div class="shipment_title">
          <a class="shipment_name">
            <app-button [buttonSize]="'primary'" [buttonStyle]="'text'">{{
              item.amazonShipmentId
            }}<span class="shipment_link ms-2 hand" (click)="openOnAmazon(item)" *ngIf="item.amazonShipmentId">
              <i class="fal fa-external-link-square-alt"></i>
            </span></app-button>
          </a>
          <div class="shipment_id">{{ item.shipmentName }}</div>
        </div>
        <div class="sku d-flex align-items-center">
          <div
          class="sku_image"
          [style.backgroundImage]="'url(' + item.Image + ')'"
        ></div>
    
        <div class="sku_header">
          <div class="sku_title control-label">
            {{item.title }}
          </div>
          <div class="sku_chip-wrapper">
            <app-sku-chip
              [name]="'SKU'"
              [value]="item.sku"
              [link]="
                item.AccountType === 'Amazon'
                  ? 'https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' +
                      item.sku
                  : 'https://seller.walmart.com/item/list?filters=%257B%2522productOfferId%2522%253A%2522'+  item.sku +'%2522%257D'
                     
              "
            ></app-sku-chip>
            <app-sku-chip
              [name]="'ASIN'"
              [value]="item.asin"
              [link]="
              item.AccountType === 'Amazon'
                  ? 'https://amazon.com/dp/' + item.asin ||
                    data.asin + '?th=1&psc=1'
                  : 'https://www.walmart.com/ip/' + item.asin + '/?selected=true'
              "
            ></app-sku-chip>
          </div>
        </div>
        </div>
        <i class="fal fa-times-circle ms-auto hand" (click)="deleteSku(i)"></i>
      </div>
      <div class="amazon-case-template">
        <div class="amazon-case">
            <div class="amazon-case_body">
                <div  class="amazon-case_body--templateText h-100" [innerHtml]="item?.selectedText">
                </div>
            </div>
        </div>
      </div>
      <div class="text-right mt-2">
        <app-button  [buttonSize]="'action'" (click)="openLink(item,i)">Open Case</app-button>
      </div>
    </div>
  </ng-container> 
  <div class="loader" *ngIf="loader">
    <img [src]="'assets/images/nineyard-loading.gif'"/>
  </div> 
  <div class="loader" *ngIf="!multipleSelectedRows.length && !loader">
    <app-no-results [message]="'No result found'">
    </app-no-results>
  </div> 
</div>

</app-dialog>